<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="locrelpointinfo" label-width="120px" class="">
			<el-row >
				<el-col :span="24">
					<el-form-item label="设备" >
						<el-select style="width: 100%;" v-model="selecteddevid" multiple filterable placeholder="请选设备" @change="selectDev">
							<el-option v-for="item in devList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div style="text-align: center;">
			<el-button v-show="!editok" type="primary" @click="editok = true">修改</el-button>
			<el-button v-show="editok" plain @click="closeDlg">取消</el-button>
			<el-button v-show="editok" type="primary" @click="saveLocPointRel">保存</el-button>
		</div>
		
	</div>
</template>

<script> 
	import { addLocRelRealDev, queryRealDevPage } from '/static/apiUrl.js'
	export default {
		name : 'AddLocDevice',
		data() {
			return {
				editok: false,
				selecteddevid : '',
				locrelpointinfo : {
					locid : '',
					devid : '',
				},
				devList : [],
				
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			add : {
				type : Boolean,
				required : false,
				default : false,
			},
			selectedloc: {
				type: Object,
				required: true
			},
		},
		watch: {
			add : {
				immediate: true,
				handler(newVal) {
					if(newVal == true){
						this.editok = true
					}else{
						this.editok = false
					}
				}
			},
			selectedloc : {
				immediate: true,
				handler(newVal) {
					this.locrelpointinfo.locid = newVal.id
					this.locrelpointinfo.orgid = newVal.orgid
					this.initData()
				}
			},
		},
		methods: {
			initData(){
				queryRealDevPage({
					oid : this.locrelpointinfo.orgid,
					pagenum : 1 ,
					pagesize : 1000
				}).then(res => {
					if(0 == res.code){
						res.datas.data.forEach((set) => {
							this.devList.push(set)
						})
					}
				})
			},
			closeDlg() {
				this.editok = false
				if(this.add){
					this.$emit("needRelRefrash",false,false)
				}
			},
			saveLocPointRel(){
				if(this.locrelpointinfo.locid == ''){
					this.$message({
						showClose: true,
						message: "请完善数据",
						type: 'warning'
					});
					return;
				}
				console.log(this.selecteddevid)
				if(this.selecteddevid == null || this.selecteddevid.length == 0){  //编辑
					this.$message({
						showClose: true,
						message: "请选择设备",
						type: 'warning'
					});
				}else{ //新增
					let addrel = []
					this.selecteddevid.forEach((item) => {
						addrel.push({
							devid : item,
							locid : this.locrelpointinfo.locid
						})
					})
					addLocRelRealDev(addrel).then(res => {
						if(0 == res.code){
							this.$message({
								showClose: true,
								message: "添加成功",
								type: 'success'
							});
							this.$emit("needRelRefrash",true,false)
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
					}) 
				}
			},
			selectDev(v){
				
			},
			
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>